export default __webpack_public_path__ + "static/5-c34ed6eea730ec75b1934e16e9673357.png";